<template>
<div class="fj">
    <!--展示用的-->
   <swiper :options="swiperOption" v-if="!canUpload&&AttachmentList.length>0">
        <swiper-slide v-for="(item, index) in AttachmentList" :key="index" class="longText" style="width: 600%; transition-duration: 0.6s; transform: translate3d(0px, 0px, 0px);">
            <div style="display:flex; flex-direction: column;">
            <div class="div_img" v-if="GetFileType(item.url)" >
            <img style="max-width:80px;max-height:60px;"   :src="item.url"  @click="PreviewFile(item)" />
            </div>
            <div class="div_img" v-if="!GetFileType(item.url)">
                <img    @click="PreviewFile(item)" style="max-height:60px;" src="../assets/7.png"/>
            </div>
            
           
            </div>
        </swiper-slide>
    
    </swiper>

<!--上传用的-->
    <swiper :options="swiperOption" v-if="canUpload&&AttachmentList.length>0">
        <swiper-slide v-for="(item, index) in AttachmentList" :key="index" class="longText" style="width: 600%; transition-duration: 0.6s; transform: translate3d(0px, 0px, 0px);">
            <div style="display:flex; flex-direction: column;">
            <div v-if="GetFileType(item.url)"  class="div_img" >
                <img style="max-width:80px;max-height:60px;"   :src="item.url"  @click="PreviewFile(item)" />
            </div>
             <div class="div_img" v-if="!GetFileType(item.url)">
                 <img    @click="PreviewFile(item)" style="max-height:60px;" src="../assets/7.png"/>
            </div>
            </div>
            <span class="delete" v-if="canUpload" @click="DeleteThis(index)">
                <img src="../assets/11.png" width="100%" />
            </span>
        </swiper-slide>
     
    </swiper>
    <p class="upload" @click="ChooseFiles()" v-if="canUpload">
        <span>点击上传</span>
    </p>
    <input type="file" id="file-input" style="display:none" />
    

    <div class="page-popup">
        <div class="page-popup-wrapper">
        <div  v-if="showPreview" popup-transition="popup-fade" class="imagePreview" :modal="true" >
            <span class="delete">
            <img src="../assets/11.png" width="100%" @click="CloseImgPreview"/>
            </span>
            <audio id="audioPreview" :src="AudioUrl" controls="controls" loop="false" hidden="true"></audio>
            <mt-button @click.native='autoPlay' v-show="showAudio" type='primary' size='large'>{{AudioButtonName}}</mt-button>
            <video  style="max-width:100%;" id="videoPreview" v-show="showVideo" :src="VideoUrl" controls="controls" loop="false"></video>
            <img id="imgPreview" v-show="showImg" :src="ImgUrl" />
        </div>
        </div>
    </div>
</div>



</template>
<style>
.imagePreview {
    top: 25px;
    width: 80%;
    height: auto;
    border-radius: 8px;
    padding: 10px;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    z-index: 3000;
    position: fixed;
    background: #fff;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: .2s ease-out;
    transition: .2s ease-out;
    border:1px solid #40b4e5
}
 .delete{position: absolute;right: -10px;top: -10px;width: 40px;}

.fj img {
    width: 70%;
    display: block;
    margin: 0 auto;
    }
</style>
<script>
import {
    Toast,
    Indicator,
    MessageBox
} from 'mint-ui';
const {BlobServiceClient, AnonymousCredential} = require("@azure/storage-blob")
export default {
    data() {
        var _self = this
        return {
        
        AudioButtonName : '播放',
            showPreview: false,
            showAudio: false,
            showVideo: false,
            showImg: false,
            ImgUrl: "",
            VideoUrl: "",
            AudioUrl: "",
        Attachment:{
            AttachmentUrl:'',
            FolderName:'',
            AttachmentName:'',
            FileType:0,
            FileSize:0,
            ActivityId:0
        },
      AttachmentList:this.value,
      curDate:new Date(),
      CDNConfiguration:{},
            stsToken: null,
           
            AttachFile: null,
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 0,
                slidesPerGroup: 4,
                loop: false,
                loopFillGroupWithBlank: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
               
            },
        }
    },
    computed: {},
    watch: {
          value: function (newOne, oldOne) {
             var that = this;
          
             //that.AttachmentList = [];

             if (that.value.length>0) {
                 that.value.forEach((item, index) => {
                   
                      that.AttachmentList=that.value;
                 });
                 
             }
             
            console.log(that.value);   
         },
       
         attachmentList: function (newOne, oldOne) {
             var that = this;
             that.AttachmentList = newOne;
             
         }, 
    },
    created() {
        var that=this;
        that.GetCdnConfiguration();
      
       
        if(that.value==undefined)
            that.AttachmentList =[];
        else
            that.AttachmentList =that.value;
    },
    props: ['canUpload', 'maxLength', 'value'],
    methods: {
        GetFileType(file){
            var that=this;
            var filetype=file.split('.').pop().toLowerCase();
            if(filetype=='jpg'||filetype=='JPG'||filetype=='jpeg'||filetype=='JPEG'||filetype=='PNG'||filetype=='png'){
                return true;
            }else{
                return false;
            } 
        },
         GetCdnConfiguration(){
        var _self = this
        _self.$axios.get("/api/AzureStorage/GetAccessToken?storedPolicyName=null").then(async (res) =>{
            
            if(res.data!=null){
                _self.CDNConfiguration = res.data
            }
        })
        .catch(err=>{
            console.log(err)
        })
    },
    async DeleteFileToCDN(p_file){
        var _self = this
        _self.$indicator.open('删除中...')
        const account = _self.CDNConfiguration.accountName
        const accountSas = _self.CDNConfiguration.cdnSas
        const anonymousCredential = new AnonymousCredential()
        const blobServiceClient = new BlobServiceClient(
            `https://${account}.blob.core.chinacloudapi.cn${accountSas}`,
            anonymousCredential
        )
        var containerClient = blobServiceClient.getContainerClient(_self.CDNConfiguration.container)            
        var blockBlobClient = containerClient.getBlockBlobClient(_self.Attachment.FolderName + "/" + p_file.AttachmentName)     
        var deleteBlobResponse = await blockBlobClient.delete()
        _self.$indicator.close()
    },
    async UploadFileToCDN(p_file){
        return new Promise(async (resolve,reject)=>{
            var _self = this
            _self.$indicator.open('上传中...')
            const account = _self.CDNConfiguration.accountName
            const accountSas = _self.CDNConfiguration.cdnSas
            const anonymousCredential = new AnonymousCredential()
            const blobServiceClient = new BlobServiceClient(
                `https://${account}.blob.core.chinacloudapi.cn${accountSas}`,
                anonymousCredential
            )
            var containerClient = blobServiceClient.getContainerClient(_self.CDNConfiguration.container)           
            var blockBlobClient = containerClient.getBlockBlobClient(_self.Attachment.FolderName +"/" + _self.Attachment.AttachmentName)     
            var uploadBlobResponse = await blockBlobClient.uploadBrowserData(p_file, {
                maxSingleShotSize: 4 * 1024 * 1024
            });  
            _self.$indicator.close()
            resolve(blockBlobClient)
        })   
    },
    async PushFiles(){
        var _self = this;
       
        var file = _self.AttachFile.files[0] ;
       
        var ExtLen = file.name.split('.').length
       
         
      
 
            var fileExt = file.name.split('.')[ExtLen-1]
            var filename = "attach"+ new Date().getTime() + '.' + fileExt
            var newAttachment={
                AttachmentUrl:'',
                FolderName:'',
                AttachmentName:'',
                FileType:0,
                FileSize:0,
                ActivityId:0
            }
            newAttachment.ActivityId=_self.AttachFile.ActivityId;

            newAttachment.FolderName = _self.CDNConfiguration.folderName + "/" + _self.curDate.getFullYear() + '-' + (_self.curDate.getMonth() + 1) + '-' + (_self.curDate.getDate())
            newAttachment.AttachmentName = filename;
            _self.Attachment.FolderName = _self.CDNConfiguration.folderName + "/" + _self.curDate.getFullYear() + '-' + (_self.curDate.getMonth() + 1) + '-' + (_self.curDate.getDate())
            _self.Attachment.AttachmentName = filename;
            if(fileExt.toUpperCase().indexOf('JPG') != -1||fileExt.toUpperCase().indexOf('PNG') != -1||fileExt.toUpperCase().indexOf('JPEG') != -1||fileExt.toUpperCase().indexOf('GIF') != -1||fileExt.toUpperCase().indexOf('BMP') != -1){
                newAttachment.FileType = 1
            }
            else if(fileExt.toUpperCase().indexOf('MP4') != -1||fileExt.toUpperCase().indexOf('MOV') != -1){
                newAttachment.FileType = 2
            }
            else if(fileExt.toUpperCase().indexOf('MP3') != -1||fileExt.toUpperCase().indexOf('WAV') != -1||fileExt.toUpperCase().indexOf('M4A') != -1){
                newAttachment.FileType = 3
            }
            else{
                _self.$messagebox("您上传的文件格式(."+fileExt+")暂时不支持。","提示")
                return false
            }
            newAttachment.FileSize = file.size
            //上传文件到CDN服务器
           
            var result = await _self.UploadFileToCDN(file)
            if(result != null){
                newAttachment.AttachmentUrl = result.url.split('?')[0].replace(_self.CDNConfiguration.azureUrl,_self.CDNConfiguration.cdnServerUrl)
            } 
            newAttachment.displayName= file.name.split('.')[0];
            newAttachment.url=newAttachment.AttachmentUrl ;

            _self.AttachmentList.push(newAttachment);
        
           
            document.getElementById('file-input').value = ''; 
           
       
    },
    ChooseFiles(){
        var _self = this;
        var fileInput = document.getElementById("file-input");
        _self.AttachFile = fileInput
        fileInput.addEventListener("change", _self.PushFiles, false)
        fileInput.click()        
    },
    SetshowPreview(p_show_preview){
      var _self = this
     
      _self.showPreview = p_show_preview
    },
    GetImage(file_type) {
      var _self = this;
      if (file_type == 1) {
        return _self.ImageIcon;
      } else if (file_type == 2) {
        return _self.VadioIcon;
      } else {
        return _self.AudioIcon;
      }
    },
    PreviewFile(p_file) {
        var _self = this;
        if(p_file.url!=undefined){
            window.open(p_file.url);
        }
        if(p_file.AttachmentUrl!=undefined){
            window.open(p_file.AttachmentUrl);
        }
        return false;
        _self.showPreview = true;
        _self.ImgUrl = null;
        _self.VideoUrl = null;
        _self.AudioUrl = null;
        _self.showImg = false;
        _self.showVideo = false;
        _self.showAudio = false;
      
        console.log(p_file.AttachmentUrl);
       if(p_file.AttachmentUrl!=undefined){
         if(_self.GetFileType(p_file.AttachmentUrl)){
            _self.ImgUrl = decodeURIComponent(p_file.AttachmentUrl);
            _self.showImg = true;
         }else{
            _self.showVideo = true;
            _self.VideoUrl = decodeURIComponent(p_file.AttachmentUrl);
         }
                 

        }else{
            if(_self.GetFileType(p_file.url)){
                _self.ImgUrl =decodeURIComponent(p_file.url)
                _self.showImg = true;
            }else{
                _self.showVideo = true;
            _self.VideoUrl = decodeURIComponent(p_file.url);
            }
            
        }
      
        
        if (p_file.FileType == 2) {
            
        }
       
    },
    RemoveFile(p_item){
        var _self = this
        _self.DeleteFileToCDN(p_item)
        ArrayOp.removeObject(_self.AttachmentList, p_item)
    },

        DeleteThis(index) {
            var that = this;
            MessageBox.confirm('', {
                title: '提示',
                message: '确定要删除此附件吗?',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(action => {
                that.AttachmentList.splice(index, 1);
            }).catch(error => {
                return;
            });
        },
        GoToAttach(item) {
            var that = this;
            
            if (!that.canUpload) {
                window.open(item.AttachmentUrl);
            }
        },
        CloseImgPreview(){
            var _self = this
            _self.showPreview = false
            _self.ImgUrl = null
            _self.VideoUrl = null
            _self.AudioUrl = null
            _self.showImg = false
            _self.showVideo = false
            _self.showAudio = false
           console.log(123);
            _self.$emit('SetshowPreview',_self.showPreview)
      },
      
    }
}
</script>
